import React, { FC } from 'react';
import { useWatch } from 'react-hook-form';

// Types
import { EditStylesProps } from '@/types';

const EditGridStylesForm: FC<EditStylesProps> = ({
  register,
  chartData,
  control,
}) => {
  const chartMeanStrokeColor = useWatch({
    control,
    defaultValue: '#1E1E1E',
    name: 'chartMeanStrokeColor',
  });
  const gridLineColor = useWatch({
    control,
    defaultValue: '#DDDDDD',
    name: 'theme.grid.line.stroke',
  });
  const annotationFontColor = useWatch({
    control,
    defaultValue: '#000000',
    name: 'theme.annotations.text.fill',
  });

  return (
    <div>
      <h5 className="text-lg pt-4 pb-2 font-bold">Cuadrícula</h5>
      <div className="flex flex-col py-1">
        <label htmlFor="chart-mean-stroke-width">
          Grosor de la media (en pixeles):
        </label>
        <input
          type="number"
          step="0.001"
          min="0"
          id="chart-mean-stroke-width"
          disabled={chartData.length === 0}
          className="rounded-lg border-2 border-gray-500 bg-white-ish"
          {...register('chartMeanStrokeWidth', {
            valueAsNumber: true,
          })}
        />
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="chart-grid-stroke-width">
          Grosor de la cuadrícula (en pixeles):
        </label>
        <input
          type="number"
          step="0.001"
          min="0"
          id="chart-grid-stroke-width"
          disabled={chartData.length === 0}
          className="rounded-lg border-2 border-gray-500 bg-white-ish"
          {...register('theme.grid.line.strokeWidth', {
            valueAsNumber: true,
          })}
        />
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="grid-line-color">Color de cuadrícula:</label>
        <div className="w-full flex items-center py-2">
          <span className="pr-3">{(gridLineColor || '').toUpperCase()}</span>
          <input
            type="color"
            id="grid-line-color"
            disabled={chartData.length === 0}
            className="w-6 h-6 cursor-pointer"
            {...register('theme.grid.line.stroke')}
          />
        </div>
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="chart-mean-stroke-color">Color de la media:</label>
        <div className="w-full flex items-center py-2">
          <span className="pr-3">
            {(chartMeanStrokeColor || '').toUpperCase()}
          </span>
          <input
            type="color"
            id="chart-mean-stroke-color"
            disabled={chartData.length === 0}
            className="w-6 h-6 cursor-pointer"
            {...register('chartMeanStrokeColor')}
          />
        </div>
      </div>
      <div className="flex flex-col py-1">
        <label htmlFor="annotation-font-color">
          Color de la fuente de las etiquetas:
        </label>
        <div className="w-full flex items-center py-2">
          <span className="pr-3">
            {(annotationFontColor || '').toUpperCase()}
          </span>
          <input
            type="color"
            id="annotation-font-color"
            disabled={chartData.length === 0}
            className="w-6 h-6 cursor-pointer"
            {...register('theme.annotations.text.fill')}
          />
        </div>
      </div>
    </div>
  );
};

export default EditGridStylesForm;
